export const selectAwsS3UploadKit = (state) => state.awsS3UploadKit;

export const selectAwsS3UploadKitAsset = (state) => state.awsS3UploadKit.asset;

export const selectAwsS3UploadKitAd = (state) => state.awsS3UploadKit.ad;
